import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * Botón "Instalar app". En Android y escritorio usa el aviso nativo
 * (`beforeinstallprompt`); en iPhone no existe esa API, así que explica
 * el camino manual. Se oculta si la app ya está instalada.
 */
export default function Instalar() {
  const [evento, setEvento] = useState(null);
  const [ios, setIos] = useState(false);
  const [instalada, setInstalada] = useState(false);
  const [ayuda, setAyuda] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    setInstalada(standalone);
    setIos(/iphone|ipad|ipod/i.test(navigator.userAgent) && !standalone);

    const alPrompt = (e) => {
      e.preventDefault();
      setEvento(e);
    };
    const alInstalar = () => {
      setInstalada(true);
      setEvento(null);
    };
    window.addEventListener("beforeinstallprompt", alPrompt);
    window.addEventListener("appinstalled", alInstalar);
    return () => {
      window.removeEventListener("beforeinstallprompt", alPrompt);
      window.removeEventListener("appinstalled", alInstalar);
    };
  }, []);

  if (instalada || (!evento && !ios)) return null;

  async function instalar() {
    if (evento) {
      evento.prompt();
      await evento.userChoice.catch(() => {});
      setEvento(null);
    } else {
      setAyuda(true);
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={instalar}
        className="no-imprimir borde inline-flex items-center gap-1.5 rounded-full border px-3 py-2 text-xs font-semibold transition hover:bg-[color:var(--acento-suave)] hover:text-[color:var(--acento-texto)] active:translate-y-px"
      >
        <Download className="h-3.5 w-3.5" aria-hidden="true" />
        Instalar app
      </button>

      {ayuda && (
        <div
          role="dialog"
          aria-label="Cómo instalar en iPhone"
          className="no-imprimir borde superficie fixed inset-x-3 top-16 z-50 rounded-2xl border p-4 shadow-2xl sm:left-auto sm:right-4 sm:max-w-sm"
        >
          <div className="flex items-start justify-between gap-3">
            <p className="text-sm leading-relaxed">
              En Safari toca <strong>Compartir</strong> y luego <strong>Agregar a pantalla de inicio</strong>.
            </p>
            <button type="button" onClick={() => setAyuda(false)} aria-label="Cerrar" className="texto-3 p-1">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
